/* ─── Token'dan kullanıcı bilgisi al ─── */
export const getUser = () => {
  try {
    const raw = localStorage.getItem('adminUser');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/* ─── Login sonrası kullanıcıyı kaydet ─── */
export const saveUser = (user, token) => {
  localStorage.setItem('adminUser', JSON.stringify(user));
  if (token) {
    localStorage.setItem('token', token);
    // Aynı sekmede storage event tetiklenmez, manuel fırlat
    window.dispatchEvent(new Event('tokenUpdated'));
  }
};

/* ─── Çıkışta temizle ─── */
export const clearUser = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('adminUser');
};

/* ─── Super Admin mı? (isSuperAdmin true VEYA permissions ['*'] içeriyorsa) ─── */
export const isSuperAdminUser = (user) => {
  if (!user) return false;
  return user.isSuperAdmin === true || user.permissions?.includes('*');
};

/* ─── İzin kontrolü ─── */
export const hasPermission = (perm) => {
  const user = getUser();
  if (!user) return false;
  if (isSuperAdminUser(user)) return true;
  return user.permissions?.includes(perm) ?? false;
};

/* ─── Tüm izin anahtarları ve etiketleri ─── */
export const ALL_PERMISSIONS = [
  { key: 'dashboard',            label: 'Dashboard',          group: 'Genel'           },
  { key: 'bonus.pending',        label: 'Bekleyenler',         group: 'Bonus Talepleri' },
  { key: 'bonus.completed',      label: 'Onaylananlar',        group: 'Bonus Talepleri' },
  { key: 'bonus.rejected',       label: 'Reddedilenler',       group: 'Bonus Talepleri' },
  { key: 'settings.bonuses',     label: 'Bonus Yönetimi',      group: 'Ayarlar'         },
  { key: 'settings.domain',      label: 'Domain Yönetimi',     group: 'Ayarlar'         },
  { key: 'settings.site',        label: 'Genel Ayarlar',       group: 'Ayarlar'         },
  { key: 'settings.verification', label: 'Doğrulama Monitörü', group: 'Ayarlar'         },
  { key: 'user.blacklist',       label: 'Bonus Blacklist',     group: 'Kullanıcı'       },
  { key: 'user.callme',          label: 'Beni Ara Blacklist',  group: 'Kullanıcı'       },
  { key: 'financial.dashboard',  label: 'Finans Dashboard',    group: 'Finansal'        },
  { key: 'financial.kasa',       label: 'Kasa Takip',          group: 'Finansal'        },
  { key: 'financial.gunluk',     label: 'Günlük Hareketler',   group: 'Finansal'        },
  { key: 'financial.odeme',      label: 'Ödemeler',            group: 'Finansal'        },
  { key: 'financial.tahsilat',   label: 'Tahsilat',            group: 'Finansal'        },
  { key: 'financial.virman',     label: 'Virman',              group: 'Finansal'        },
  { key: 'financial.yontemler',  label: 'Ödeme Yöntemleri',    group: 'Finansal'        },
  { key: 'financial.commission', label: 'Komisyon Hesaplama',  group: 'Finansal'        },
  { key: 'user.sms',             label: 'SMS Yönetimi',        group: 'Kullanıcı'       },
  { key: 'user.management',      label: 'Kullanıcı Yönetimi',  group: 'Yönetim'         },
];
